import { LOS_VIEW_TYPE } from "../shared/enum.js";
import { store } from "../elementBaseClass.js";

export const DEFAULT_FIELDS = [
  "sponsorABONo",
  "aboNo",
  "countryCode",
  "name",
  "entryDate",
  "phone",
  "email",
  "address",
];

export const LOS_DEFAULT_FIELDS = ["level", ...DEFAULT_FIELDS, "renewalDate"];

/**
 * Remove saved KPI ids that are no longer present in market configuration.
 * `undefined`/`null` means configuration is unavailable; an empty array is authoritative.
 */
export const filterKpisByConfiguration = (kpis = [], availableKpis) => {
  if (availableKpis === undefined || availableKpis === null) return kpis;

  const configuredIds = new Set(availableKpis.map((kpi) => (typeof kpi === "string" ? kpi : kpi.id)));
  return kpis.filter((kpi) => configuredIds.has(typeof kpi === "string" ? kpi : kpi.id));
};

/**
 * Method to build the fields to be shown
 * on the exports file
 * @returns fields[]
 */
export const getFields = (isFullMap, moduleId, exportSelectedKpis) => {
  const { hideVolume, exportSavedKpiList = [], availableKpis } = store.getState();
  const configuredSavedKpis = filterKpisByConfiguration(exportSavedKpiList, availableKpis);
  let defaultFieldKeys = DEFAULT_FIELDS;

  if (moduleId === LOS_VIEW_TYPE.LOS) {
    defaultFieldKeys = LOS_DEFAULT_FIELDS;
  }

  // Include configured saved KPIs if user is not hiding them.
  if (configuredSavedKpis.length > 0 && hideVolume === false && isFullMap === false) {
    return [...defaultFieldKeys, ...configuredSavedKpis];
  }

  if (isFullMap === true && hideVolume === false) {
    if (exportSelectedKpis === true) {
      return [...defaultFieldKeys, ...configuredSavedKpis];
    }
    return [...defaultFieldKeys, ...(availableKpis || [])];
  }
  return defaultFieldKeys;
};
